import { markAsRead } from "@api/stores/notifications/markAsRead/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  INotificationGetAllParams,
  INotificationsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<INotificationsResponse>>,
  IPathBaseParam,
  IPaginationParams & INotificationGetAllParams
>("stores.notifications");

export const notifications = {
  ...getAllApis,
  markAsRead,
};
